export default __webpack_public_path__ + "static/media/dyeing7.4c3399a5.png";